import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/UI/Typography/Text';
import { ModalWrapper } from './styles';
import { Check, Close } from '@/components/Icon';
import { Flex } from '@/layout';
import { Modal } from '@mui/material';

import { theme } from '@/theme/Theme';

interface P12ResModalProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  response?: string | null;
  resStatus?: boolean | null;
}

const P12ResModal = ({ showModal, setShowModal, response, resStatus }: P12ResModalProps) => {

  // 關閉時將setResponse設為false
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <Modal
      open={showModal}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableEnforceFocus
    >
      <ModalWrapper>
        <Flex flexDirection={'column'} alignItems={'center'} gridGap={15}>
          {
            response && resStatus ? (
              <Check.CheckSVG width="60px" height="60px" fill={theme.colors.secondary500} />
            )
              : (
                <Check.CancelSVG width="60px" height="60px" fill={theme.colors.red} />
              )
          }
          <Text>{response}</Text>
        </Flex>
      </ModalWrapper>
    </Modal>
  );
};

export default P12ResModal;
